import {DIALOG_VISIBLE} from "./actions";
import {combineReducers} from "redux";

function dialog(state = {visible: false, url: null}, action) {
    switch (action.type) {
        case DIALOG_VISIBLE:
            return {visible: action.visible, url: action.url};
        default:
            return state;
    }
}

export const reducers = combineReducers({dialog});


// WEBPACK FOOTER //
// ./src/course_details/reducers.js